const { LAYOUT_STYLE } = require('constants/featureFlags');
const withFeatureFlag = require('@cld/with-feature-flags').default;

const featureFlag = withFeatureFlag({ flagName: 'layoutStyle', bulk: true })({
  IfWizard: {
    [LAYOUT_STYLE.WIZARD]: () => import('components/Widget/Header/Wizard'),
  },
  IfFooterLayout: {
    [LAYOUT_STYLE.SINGLE]: () => import('components/Widget/Footer/FooterSingle'),
    [LAYOUT_STYLE.WIZARD]: () => import('components/Widget/Footer/FooterWizard'),
  },
});

Object.assign(exports, featureFlag, { __esModule: true });
